import { gsap } from './gsap';
import { revealUp } from './revealUp';

const imageAnimations = () => {
  const revealUpImgs = gsap.utils.toArray('.reveal-up img');
  const coreValuesImgs = gsap.utils.toArray('.values-list li');

  if (revealUpImgs.length > 0) {
    revealUpImgs.forEach((img) => {
      revealUp(img, img);
    });
  }

  if (coreValuesImgs.length > 0) {
    coreValuesImgs.forEach((value) => {
      const img = value.querySelector('.values-list__img');
      gsap.from(img, {
        autoAlpha: 0,
        top: 0,
        scrollTrigger: {
          trigger: value,
          start: '70% bottom',
          toggleActions: 'play reverse play reverse'
        }
      });
    });
  }
};

export default imageAnimations;
